import { useRegisterCommands } from "components/Layout/Panels/VSCode/useRegisterCommands";
import { usePitcher } from "features/utils/usePitcher";
import { useCapabilities } from "hooks/pitcher/useCapabilities";
import { usePermissions } from "hooks/pitcher/usePermissions";
import { useEffect, useState } from "react";
import * as vscode from "vscode";

import { useVSCodeExtensionInitializedEffect } from "hooks/useVSCodeExtensionInitializedEffect";

import { useCreateTasksConfigCommand } from "../definitions/configFile/useCreateTasksConfigCommand";
import { useOpenTasksConfigCommand } from "../definitions/configFile/useOpenTasksConfigCommand";

export const useRegisterConfigFilesCommands = (): void => {
  const pitcherPermissions = usePermissions();
  const pitcherCapabilities = useCapabilities();
  const [hasConfigFile, setHasConfigFile] = useState(false);
  const pitcher = usePitcher();

  const createTasksCommand = useCreateTasksConfigCommand();
  const openTasksCommand = useOpenTasksConfigCommand();

  const availableCommand = hasConfigFile
    ? openTasksCommand
    : createTasksCommand;

  const isFsWritable =
    pitcherCapabilities.fs?.operations && pitcherPermissions.fs?.operation;

  useVSCodeExtensionInitializedEffect(() => {
    vscode.commands.executeCommand(
      "setContext",
      "csb.hasTaskConfig",
      hasConfigFile,
    );
  }, [hasConfigFile]);

  useEffect(() => {
    pitcher.clients.fs.stat(".codesandbox/tasks.json").then((result) => {
      if (result.type === "ok") {
        setHasConfigFile(true);
      } else {
        setHasConfigFile(false);
      }
    });

    const watcher = pitcher.clients.fs.watch(
      ".codesandbox/tasks.json",
      {},
      (event) => {
        if (event.type === "add") {
          setHasConfigFile(true);
        } else if (event.type === "remove") {
          setHasConfigFile(false);
        }
      },
    );

    return () => {
      watcher.then((w) => {
        if (w.type === "success") {
          w.dispose();
        }
      });
    };
  }, []);

  useRegisterCommands(
    isFsWritable
      ? [
          // Add open or create when file system access is allowed
          availableCommand,
        ]
      : openTasksCommand
        ? [
            // Register only open when file system access is not allowed
            openTasksCommand,
          ]
        : [],
    [isFsWritable, openTasksCommand],
  );
};
